"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectedItem = exports.SectionHeaderStyles = exports.RemoveItemButton = exports.MultiLineWrapper = exports.MultiLineStyledControlWrapper = exports.MultiComboboxWrapper = exports.ComboboxDivider = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _ControlWrapper = require("../../../shared/aria-support-components/ControlWrapper.styled");
var _input = require("../../../components/inputs/input/input.tokens");
var SelectedItem = exports.SelectedItem = _styledComponents.default.div.withConfig({
  displayName: "Styles__SelectedItem",
  componentId: "sc-ic02il-0"
})(["background:", ";align-items:center;border-radius:", ";display:inline-flex;padding:", ";height:", ";cursor:pointer;"], function (props) {
  return props.color || props.theme.sys.color.background.primary['1'];
}, _globalTokens.globalBorder.radius['2'], function (props) {
  return props.height === _input.InputHeight.LARGE ? "".concat(_globalTokens.globalSpacing['100'], " ").concat(_globalTokens.globalSpacing['100'], " ").concat(_globalTokens.globalSpacing['100'], " ").concat(_globalTokens.globalSpacing['200']) : "0 ".concat(_globalTokens.globalSpacing['100'], " 0 0");
}, function (props) {
  return props.height === _input.InputHeight.SMALL ? '32px' : '35px';
});
var RemoveItemButton = exports.RemoveItemButton = _styledComponents.default.div.withConfig({
  displayName: "Styles__RemoveItemButton",
  componentId: "sc-ic02il-1"
})(["cursor:pointer;padding-left:", ";color:#646464;"], _globalTokens.globalSpacing['100']);
var MultiLineStyledControlWrapper = exports.MultiLineStyledControlWrapper = (0, _styledComponents.default)(_ControlWrapper.StyledControlWrapper).withConfig({
  displayName: "Styles__MultiLineStyledControlWrapper",
  componentId: "sc-ic02il-2"
})(["height:100%;min-height:", ";align-items:stretch;"], function (_ref) {
  var height = _ref.height;
  return height ? _input.tokens.size.height[height] : undefined;
});
var MultiComboboxWrapper = exports.MultiComboboxWrapper = _styledComponents.default.div.withConfig({
  displayName: "Styles__MultiComboboxWrapper",
  componentId: "sc-ic02il-3"
})(["position:relative;display:flex;width:100%;"]);
var MultiLineWrapper = exports.MultiLineWrapper = _styledComponents.default.div.withConfig({
  displayName: "Styles__MultiLineWrapper",
  componentId: "sc-ic02il-4"
})(["display:inline-flex;flex-wrap:wrap;width:100%;align-items:stretch;align-content:stretch;cursor:text;gap:", ";padding:", ";"], _globalTokens.globalSpacing['100'], function (props) {
  return props.height === _input.InputHeight.LARGE ? _globalTokens.globalSpacing['100'] : 0;
});
var SectionHeaderStyles = exports.SectionHeaderStyles = _styledComponents.default.li.withConfig({
  displayName: "Styles__SectionHeaderStyles",
  componentId: "sc-ic02il-5"
})(["display:flex;align-items:center;justify-content:space-between;background:", ";height:44px;padding:0 ", ";:not(:first-child){border-top:1px solid #e7e7f3;}cursor:pointer;outline:none;"], function (props) {
  return props.isFocused ? props.theme.sys.color.background.primary['1'] : '';
}, _globalTokens.globalSpacing['200']);
var ComboboxDivider = exports.ComboboxDivider = _styledComponents.default.div.withConfig({
  displayName: "Styles__ComboboxDivider",
  componentId: "sc-ic02il-6"
})(["display:flex;border-left:", ";"], _input.tokens.border.default);